import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const Header = styled.div`
  display: flex;
  height: 37px;
  justify-content: space-between;
  align-items: center;
`;

export const Title = styled.span`
  font-family: Montserrat;
  font-size: 18px;
  font-weight: 700;
  color: #000000;
`;
